import type { Node } from "@tiptap/core"
import TiptapTypography from "@tiptap/extension-typography"
import StarterKit from "@tiptap/starter-kit"
import { DropCapExtension } from "./extensions/drop-cap.js"
import { Highlight } from "./extensions/highlight.js"
import { Callout } from "./nodes/callout-node.js"
import { CodeBlockNode } from "./nodes/code-block.js"
import { EmbedNode } from "./nodes/embed/embed-node.js"
import { Heading } from "./nodes/heading.js"
import { ImageNode } from "./nodes/imageNode.js"
import { MathBlock } from "./nodes/math-block.js"
import { MathInline } from "./nodes/math-inline.js"
import { Paragraph } from "./nodes/paragraph.js"
import { Snippet } from "./nodes/snippet.js"
import { Subscribe } from "./nodes/subscribe.js"

type Options = {
  dropcursor?: Record<string, any> | false
  dropCap?: boolean
  link?: false
  Snippet?: Node<any>
  Subscribe?: Node<any>
  CodeBlock?: Node<any>
  MathBlock?: Node<any>
  MathInline?: Node<any>
  Embed?: Node<any>
  Image?: Node<any>
  userName?: string
}
export function extensions(options: Options = {}): any {
  const subscribeExtension =
    options.Subscribe ??
    Subscribe.configure({
      userName: options.userName,
    })

  const codeBlockExtension =
    options.CodeBlock ??
    CodeBlockNode.configure({
      HTMLAttributes: {
        spellcheck: false,
      },
    })

  return [
    StarterKit.configure({
      heading: false,
      codeBlock: false,
      paragraph: options.dropCap === false ? undefined : false,
      dropcursor: options.dropcursor ?? false,
      link:
        options.link === false ? false : { autolink: true, openOnClick: false },
    }),
    Highlight,
    ...(options.dropCap === false ? [] : [DropCapExtension, Paragraph]),
    Callout,
    TiptapTypography,
    Heading,
    options.Snippet ?? Snippet,
    subscribeExtension,
    codeBlockExtension,
    options.Image ?? ImageNode,
    options.MathBlock ?? MathBlock,
    options.MathInline ?? MathInline,
    options.Embed ?? EmbedNode,
  ]
}
